/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */
/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Tooltip from "@mui/material/Tooltip";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import MDProgress from "components/MDProgress";
import { mapTransactionStatus } from "utils/transactionStatus";

// Images
import logoXD from "assets/images/small-logos/logo-xd.svg";
import logoAtlassian from "assets/images/small-logos/logo-atlassian.svg";
import logoSlack from "assets/images/small-logos/logo-slack.svg";
import logoSpotify from "assets/images/small-logos/logo-spotify.svg";
import logoJira from "assets/images/small-logos/logo-jira.svg";
import logoInvesion from "assets/images/small-logos/logo-invision.svg";
import team1 from "assets/images/team-1.jpg";
import team2 from "assets/images/team-2.jpg";
import team3 from "assets/images/team-3.jpg";
import team4 from "assets/images/team-4.jpg";
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { saveAs } from 'file-saver'; 
export default function data() {
  function formatNumber(n) {
    if (!n) return '0.00';
    let parts = n.toString().split(".");

    // Apply comma as thousands separator
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    // Ensure three decimal places
    if (parts[1]) {
      if (parts[1].length === 1) {
        parts[1] += "0"; // Add two zeros if there's only one digit
      } else if (parts[1].length > 3) {
        parts[1] = parts[1].substr(0, 2); // Truncate to three digits if longer
      }
      // No else needed for exactly three digits
    } else {
      parts[1] = "00"; // Add ".000" if there's no decimal part
    }

    return parts.join(".");
  }
  function monthConverter(inputDate) {
    const parts = inputDate.split("-");
    const month = parseInt(parts[0], 10);
    const year = parseInt(parts[1], 10);

    // Create a JavaScript Date object
    const date = new Date(year, month - 1, 1); // Note: Months are 0-based, so we subtract 1

    // Format the date as "MMM-yyyy" (e.g., "Oct-2023")
    const formattedDate = date.toLocaleDateString('en-US', { year: 'numeric', month: 'short' });
    return formattedDate;
  }
  function readableFormatDate(dateStr){
    const dateObj = new Date(dateStr);

    const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    const month = months[dateObj.getMonth()];
    const day = dateObj.getDate();
    const year = dateObj.getFullYear();
    const hours = dateObj.getHours() > 12 ? dateObj.getHours() - 12 : dateObj.getHours();
    const minutes = String(dateObj.getMinutes()).padStart(2, '0');
    const seconds = String(dateObj.getSeconds()).padStart(2, '0');
    const period = dateObj.getHours() >= 12 ? 'PM' : 'AM';

    const formattedDate = `${month} ${day}, ${year}, ${hours}:${minutes}:${seconds} ${period}`;
    return formattedDate;
  }

  function readableFormatDate2(dateStr) {
    const dateObj = new Date(dateStr);

    const day = String(dateObj.getDate()).padStart(2, '0');
    const month = String(dateObj.getMonth() + 1).padStart(2, '0'); // Adding 1 because months are zero-indexed
    const year = dateObj.getFullYear();
    const hours = dateObj.getHours();
    const minutes = String(dateObj.getMinutes()).padStart(2, '0');
    const seconds = String(dateObj.getSeconds()).padStart(2, '0');
    // const period = dateObj.getHours() >= 12 ? 'PM' : 'AM';

    const formattedDate = `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
    return formattedDate;
  }


  return {
    auditTrailcolumns: [
      { Header: "user id", accessor: "userId", width: "10%", align: "left" },
      { Header: "Merchant name / Reference Company Name / Name", accessor: "userName", width: "10%", align: "left" },
      { Header: "module", accessor: "module", width: "10%", align: "left" },
      { Header: "Sub Module", accessor: "subModule", width: "10%", align: "left" },
      // { Header: "Activity Time", accessor: row => readableFormatDate(row.actTime), width: "10%", align: "left" },
      { Header: "Request Ip", accessor: "reqIp", width: "10%", align: "left" },
      { Header: "User Level", accessor: "userLevel", width: "10%", align: "left" },
      {
        Header: "Summary",
        accessor: "summary",
        width: "10%",
        align: "left",
        Cell: ({ row }) => (
          <button
            onClick={() => {
              const blob = new Blob([row.original.summary], { type: "text/plain;charset=utf-8" });
              const datatime = new Date().toISOString().replace(/[-:]/g, '').replace('T', '_').replace(/\..+/, '');
              saveAs(blob, `Summary_${row.original.userId}_${datatime}.txt`);
              
            }}
          >
            Download
          </button>
        ),
      },
    ],
    transactionSummarycolumns: [
      { Header: "Date", accessor: "transaction_dt", width: "10%", align: "left" },
      { Header: "MID", accessor: "mid", width: "10%", align: "left" },
      // { Header: "VLE Name", accessor: "vleName", width: "10%", align: "left" },
      
      // { Header: "Card Transaction", accessor: "pos_transactions", width: "10%", align: "left" },
      // { Header: "Card Amount", accessor: row => formatNumber(row.pos_amount), width: "10%", align: "left" },
      // { Header: "Cash Transaction", accessor: "cash_transactions", width: "10%", align: "left" },
      // { Header: "Cash Amount", accessor: row => formatNumber(row.cash_amount), width: "10%", align: "left" },
      {
        Header: "Total Sale",
        accessor: "pos_transactions",
        Cell: ({ row }) => {
          const count = row.original.pos_transactions || 0;
          const amount = row.original.pos_amount || 0;
          return `${count} (${amount.toFixed(2)})`;
        },
        width: "10%",
        align: "left",
      },
      {
        Header: "Total Void",
        accessor: "void_transactions",
        Cell: ({ row }) => {
          const count = row.original.void_transactions || 0;
          const amount = row.original.void_amount || 0;
          return `${count} (${amount.toFixed(2)})`;
        },
        width: "10%",
        align: "left",
      },
      {
        Header: "Total Refund",
        accessor: "refund_transactions",
        Cell: ({ row }) => {
          const count = row.original.refund_transactions || 0;
          const amount = row.original.refund_amount || 0;
          return `${count} (${amount.toFixed(2)})`;
        },
        width: "10%",
        align: "left",
      }
      // { Header: "Total Sale", accessor: "pos_transactions", width: "10%", align: "left" },
      // { Header: "Total Sale Amount", accessor: "pos_amount", width: "10%", align: "left" },
      // { Header: "Total Void", accessor: "void_transactions", width: "10%", align: "left" },
      // { Header: "Total Void Amount", accessor: "void_amount", width: "10%", align: "left" },
      // { Header: "Total Refund", accessor: "refund_transactions", width: "10%", align: "left" },
      // { Header: "Total Refund Amount", accessor: "refund_amount", width: "10%", align: "left" },
    
    ],
    transactionReportcolumns: [
      { Header: "Merchant Id", accessor: "merchantId", width: "10%", align: "left" },
      { Header: "Terminal Id", accessor: "terminalId", width: "10%", align: "left" },
      { Header: "rrn", accessor: "rrn", width: "10%", align: "left" },
      { Header: "stan", accessor: "stan", width: "10%", align: "left" },
      { Header: "Transaction Amount", accessor: row => formatNumber(row.transactionAmount), width: "10%", align: "left" },
      { Header: "Type", accessor: "type", width: "10%", align: "left" },
      { Header: "Status", accessor: "status", width: "10%", align: "left" },
      { Header: "Transaction Date", accessor: "transactionDate", width: "10%", align: "left" },
    ],
    userTablecolumns: [
      { Header: "user id", accessor: "userId", width: "10%", align: "left" },
      { Header: "First Name", accessor: "firstName", width: "10%", align: "left" },
      { Header: "Last name", accessor: "lastName", width: "10%", align: "left" },
      { Header: "Mobile No", accessor: "mobileNo", width: "10%", align: "left" },
      { Header: "Email Id", accessor: "emailId", width: "10%", align: "left" },
      { Header: "Role", accessor: row => {
        if (row.role === "MAKER") return "Admin";
        if (row.role === "G_MAKER") return "Guest Admin";
        if (row.role === "SUPERADMIN") return "Super Admin";
        return row.role;
      }, width: "10%", align: "left" },
      { Header: "Action", accessor: "action", width: "10%", align: "left" },
    ],
    merchantTablecolumns: [
      { Header: "Rec Identifier", accessor: "recIdentifier", width: "10%", align: "left" },
      { Header: "Institution Number", accessor: "institutionNumber", width: "10%", align: "left" },
      { Header: "Client Number", accessor: "clientNumber", width: "10%", align: "left" },
      { Header: "Rehistration Number", accessor: "registrationNumber", width: "10%", align: "left" },
      { Header: "Business Class", accessor: "businessClass", width: "10%", align: "left" },
      { Header: "Address Line", accessor: "addressLine1", width: "10%", align: "left" },
      { Header: "Client Branch", accessor: "clientBranch", width: "10%", align: "left" },
      { Header: "Merchant Id", accessor: "mid", width: "10%", align: "left" },
      { Header: "Company Name", accessor: "companyName", width: "10%", align: "left" },
      { Header: "Owner Name", accessor: "ownerName", width: "10%", align: "left" },
      { Header: "Account No", accessor: "accountNo", width: "10%", align: "left" },
      { Header: "Company Id", accessor: "companyId", width: "10%", align: "left" },
      { Header: "Status", accessor: row => row.status === "1" ? 'Active' : row.status === "3" ? 'Block' : 'InActive', width: "10%", align: "left" },
      { Header: "Created AT", accessor: row => readableFormatDate2(row.createdDt), width: "10%", align: "left" },
      { Header: "Action", accessor: "action", width: "10%", align: "left" },
      { Header: "IS LCR Enabled", accessor: "lcrenbale", width: "10%", align: "left" },
    ],
    merchantGroupTablecolumns: [
      { Header: "Reference compnay code", accessor: "referenceId", width: "10%", align: "left" },
      { Header: "Refrerence company Name", accessor: "referenceCompanyName", width: "10%", align: "left" },
      { Header: "Owner name", accessor: "ownerName", width: "10%", align: "left" },
      { Header: "Status", accessor: row => row.status === "1" ? 'Active' : row.status === "3" ? 'Block' : 'InActive', width: "10%", align: "left" },
      { Header: "Created AT", accessor: row => readableFormatDate2(row.createdDt), width: "10%", align: "left" },

    ],
    terminalTablecolumns: [
      { Header: "merchant id", accessor: "mid", width: "10%", align: "left" },
      { Header: "Moblie Number", accessor: "msisdn", width: "10%", align: "left" },
      { Header: "Terminal id & Username", accessor: "tid", width: "10%", align: "left" },
      { Header: "Device Type", accessor: "deviceType", width: "10%", align: "left" },
      { Header: "Name", accessor: "name", width: "10%", align: "left" },
      { Header: "Status", accessor: row => row.status === "1" ? 'Active' : row.status === "3" ? 'Block' : 'InActive', width: "10%", align: "left" },
      { Header: "Action", accessor: "action", width: "10%", align: "left" }
    ],
    allTerminalTablecolumns: [
      { Header: "Merchant id", accessor: "mid", width: "10%", align: "left" },
      { Header: "Moblie Number", accessor: "msisdn", width: "10%", align: "left" },
      { Header: "Terminal id", accessor: "tid", width: "10%", align: "left" },
      { Header: "Device Type", accessor: "deviceType", width: "10%", align: "left" },
      { Header: "Name", accessor: "name", width: "10%", align: "left" },
      { Header: "Status", accessor: row => row.status === "1" ? 'Active' : row.status === "3" ? 'Block' : 'InActive', width: "10%", align: "left" },
      { Header: "Merchant Group ID ", accessor: "merchandGroupId", width: "10%", align: "left" },
    ],
    resetTerminalTablecolumns: [
      { Header: "Moblie Number", accessor: "msisdn", width: "10%", align: "left" },
      { Header: "IMEI", accessor: "imei", width: "10%", align: "left" },
      { Header: "Terminal Id", accessor: "tid", width: "10%", align: "left" },
      { Header: "Device Type", accessor: "deviceType", width: "10%", align: "left" },
      { Header: "Status", accessor: row => row.status === "1" ? 'Active' : row.status === "3" ? 'Block' : 'InActive', width: "10%", align: "left" },
      { Header: "Action", accessor: "action", width: "10%", align: "left" }
    ],
    mposUsersTablecolumns: [
      { Header: "User ID", accessor: "userId", width: "10%", align: "left" },
      { Header: "First Name", accessor: "firstName", width: "10%", align: "left" },
      { Header: "Last Name", accessor: "lastName", width: "10%", align: "left" },
      { Header: "Mobile Number", accessor: "mobileNo", width: "10%", align: "left" },
      { Header: "Status", accessor: row => row.status === "1" ? 'Active' : row.status === "3" ? 'Block' : 'InActive', width: "10%", align: "left" },
      { Header: "Action", accessor: "action", width: "10%", align: "left" }
    ],
    merchatnUsersTablecolumns: [
      { Header: "user id", accessor: "userId", width: "10%", align: "left" },
      { Header: "First Name", accessor: "firstName", width: "10%", align: "left" },
      { Header: "Last name", accessor: "lastName", width: "10%", align: "left" },
      { Header: "Mobile No", accessor: "mobileNo", width: "10%", align: "left" },
      { Header: "Email Id", accessor: "emailId", width: "10%", align: "left" },
      { Header: "user level", accessor: "authorities[0].authority", width: "10%", align: "left" },
      { Header: "Action", accessor: "action", width: "10%", align: "left" },
    ],
    merchantAllUsersTablecolumns: [
      { Header: "user id", accessor: "userId", width: "10%", align: "left" },
      { Header: "First Name", accessor: "firstName", width: "10%", align: "left" },
      { Header: "Last name", accessor: "lastName", width: "10%", align: "left" },
      { Header: "MID", accessor: "groupMid", width: "10%", align: "left" },
      { Header: "Mobile No", accessor: "mobileNo", width: "10%", align: "left" },
      { Header: "Email Id", accessor: "emailId", width: "10%", align: "left" },
      // { Header: "user level", accessor: "authorities[0].authority", width: "10%", align: "left" },
    ],
    thirtydaysActiveTablecolumns: [
      { Header: "Username", accessor: "userId", width: "10%", align: "left" },
      { Header: "Tid", accessor: "tid", width: "10%", align: "left" },
      { Header: "First Name", accessor: "fname", width: "10%", align: "left" },
      { Header: "Last name", accessor: "lname", width: "10%", align: "left" },
      { Header: "Mobile No", accessor: "mobNo", width: "10%", align: "left" },
      { Header: "Group mid", accessor: "gmid", width: "10%", align: "left" },
      { Header: "Company Name", accessor: "companyName", width: "10%", align: "left" },
      { Header: "Status", accessor: "st", width: "10%", align: "left" },
      { Header: "Last login date", accessor: row => readableFormatDate2(row.ldt), width: "10%", align: "left" },
    ],
    preAuthTransactionsReportsColumns: [
      { Header: "Date", accessor: row => readableFormatDate2(row.transactionDate), width: "10%", align: "left", Cell: ({ value, row }) => row.original.status === '01' || row.original.status === '02' ? <span style={{ textDecoration: 'line-through', color: '#d32f2f' }}>{value}</span> : value },
      // { Header: "Company Name", accessor: "compName", width: "10%", align: "left" },
      // { Header: "Device SN", accessor: "deviceSn", width: "10%", align: "left" },
      // { Header: "Device Type", accessor: "transactionNumber", width: "10%", align: "left" },
      { Header: "MID", accessor: "merchantId", width: "10%", align: "left", Cell: ({ value, row }) => row.original.status === '01' || row.original.status === '02' ? <span style={{ textDecoration: 'line-through', color: '#d32f2f' }}>{value}</span> : value },
      { Header: "TID", accessor: "posId", width: "10%", align: "left", Cell: ({ value, row }) => row.original.status === '01' || row.original.status === '02' ? <span style={{ textDecoration: 'line-through', color: '#d32f2f' }}>{value}</span> : value },
      { Header: "Amount", accessor: row => formatNumber(row.amount), width: "10%", align: "left", Cell: ({ value, row }) => row.original.status === '01' || row.original.status === '02' ? <span style={{ textDecoration: 'line-through', color: '#d32f2f' }}>{value}</span> : value },
      {
        Header: "Status",
        accessor: row => row.responseCode === '000' || row.responseCode === '00' ? 'Approved ( '+row.responseCode+' )' : 'Declined ( '+row.responseCode+' )',
        width: "10%",
        align: "left",
        Cell: ({ value, row }) => {
          const isApproved = value && value.startsWith('Approved');
          const isVoidedOrRefunded = row.original.status === '01' || row.original.status === '02';
          return (
            <MDBox sx={{ display: "inline-block", px: 1.5, py: 0.5, borderRadius: "8px", backgroundColor: isApproved ? "#d4edda" : "#f8d7da", color: isApproved ? "#155724" : "#721c24", fontWeight: "500", fontSize: "0.75rem", whiteSpace: "nowrap", ...(isVoidedOrRefunded && { textDecoration: 'line-through' }) }}>
              {value}
            </MDBox>
          );
        },
      },
      {
        Header: "RRN", accessor: "retrievalReferenceNumber", width: "10%", align: "left",
        Cell: ({ value, row }) => {
          const isVoidedOrRefunded = row.original.status === '01' || row.original.status === '02';
          const [copied, setCopied] = useState(false);
          const [hovered, setHovered] = useState(false);
          const handleCopy = (e) => {
            e.stopPropagation();
            if (value) { navigator.clipboard.writeText(value).then(() => { setCopied(true); setTimeout(() => setCopied(false), 1500); }); }
          };
          return (
            <span
              style={{ display: "inline-flex", alignItems: "center", gap: "4px", textDecoration: isVoidedOrRefunded ? "line-through" : "none", color: isVoidedOrRefunded ? "#d32f2f" : "inherit", cursor: "default" }}
              onMouseEnter={() => setHovered(true)}
              onMouseLeave={() => setHovered(false)}
            >
              {value}
              {value && (
                <Tooltip title={copied ? "Copied!" : "Copy RRN"} placement="top">
                  <span
                    onClick={handleCopy}
                    style={{ cursor: "pointer", display: "inline-flex", alignItems: "center", color: copied ? "#4caf50" : "#757575", fontSize: "1.4rem", lineHeight: 1, visibility: hovered ? "visible" : "hidden" }}
                  >
                    {copied ? "✓" : "⎘"}
                  </span>
                </Tooltip>
              )}
            </span>
          );
        },
      },
      {
        Header: "Transaction Method",
        accessor: row => {
          const entrMode = row.entrMode;
          if (!entrMode) return "Other";
          if (entrMode.startsWith("05")) return "Contact";
          if (entrMode.startsWith("07")) return "Contactless";
          if (entrMode.startsWith("02")) return "Mag Stripe";
          if (entrMode.startsWith("01")) return "Manual";
          return "Other";
        },
        width: "10%",
        align: "left",
        Cell: ({ value, row }) => {
          if (!value) return null;
          const isVoidedOrRefunded = row.original.status === '01' || row.original.status === '02';
          const colorMap = {
            "Contact":      { bg: "#d1ecf1", color: "#0c5460" },
            "Contactless":  { bg: "#e2d9f3", color: "#432874" },
            "Mag Stripe":   { bg: "#fff3cd", color: "#856404" },
            "Manual":       { bg: "#fde8d8", color: "#7d3c0f" },
            "Other":        { bg: "#e2e3e5", color: "#383d41" },
          };
          const style = colorMap[value] || colorMap["Other"];
          return (
            <MDBox sx={{ display: "inline-block", px: 1.5, py: 0.5, borderRadius: "8px", backgroundColor: style.bg, color: style.color, fontWeight: "500", fontSize: "0.75rem", whiteSpace: "nowrap", ...(isVoidedOrRefunded && { textDecoration: 'line-through' }) }}>
              {value}
            </MDBox>
          );
        },
      },
      {
        Header: "Refund/Void",
        accessor: row => row.status === '01' ? 'Voided' : row.status === '02' ? 'Refunded' : '',
        width: "10%",
        align: "left",
        // Cell: ({ value }) => value ? (
        //   <MDBox component="span" sx={{ textDecoration: "line-through", color: "#888" }}>
        //     {value}
        //   </MDBox>
        // ) : null,
      },

      // { Header: "Surcharge Amount", accessor: row => formatNumber(row.surchangeAmount), width: "10%", align: "left" },
      // { Header: "Tip Amount", accessor: row => formatNumber(row.tipAmount), width: "10%", align: "left" },
      { Header: "Card number", accessor: "pan", width: "10%", align: "left" , Cell: ({ value, row }) => row.original.status === '01' || row.original.status === '02' ? <span style={{ textDecoration: 'line-through', color: '#d32f2f' }}>{value}</span> : value},
      { Header: "Invoice Number", accessor: "invoiceNo", width: "10%", align: "left", Cell: ({ value, row }) => row.original.status === '01' || row.original.status === '02' ? <span style={{ textDecoration: 'line-through', color: '#d32f2f' }}>{value}</span> : value },
      { Header: "Auth Id", accessor: "authId", width: "10%", align: "left" , Cell: ({ value, row }) => row.original.status === '01' || row.original.status === '02' ? <span style={{ textDecoration: 'line-through', color: '#d32f2f' }}>{value}</span> : value},
      { Header: "App Name", accessor: "appName", width: "10%", align: "left" , Cell: ({ value, row }) => row.original.status === '01' || row.original.status === '02' ? <span style={{ textDecoration: 'line-through', color: '#d32f2f' }}>{value}</span> : value},
      { Header: "Terminal rrn", accessor: "mobileRefNo", width: "10%", align: "left" , Cell: ({ value, row }) => row.original.status === '01' || row.original.status === '02' ? <span style={{ textDecoration: 'line-through', color: '#d32f2f' }}>{value}</span> : value},
      { Header: "Transaction Type", accessor: "transactionType", width: "10%", align: "left" , Cell: ({ value, row }) => row.original.status === '01' || row.original.status === '02' ? <span style={{ textDecoration: 'line-through', color: '#d32f2f' }}>{value}</span> : value},
      { Header: "Merchant Name", accessor: "compName", width: "10%", align: "left" , Cell: ({ value, row }) => row.original.status === '01' || row.original.status === '02' ? <span style={{ textDecoration: 'line-through', color: '#d32f2f' }}>{value}</span> : value},

    ],
    cashTransactionsReportsColumns: [
      { Header: "Transaction Date", accessor: row => readableFormatDate2(row.transactionDate), width: "10%", align: "left" },
      { Header: "Response Code", accessor: "responseCode", width: "10%", align: "left" },
      { Header: "Amount", accessor: "amount", width: "10%", align: "left" },
      { Header: "Transaction", accessor: "mobileRefNo", width: "10%", align: "left" },
      { Header: "Terminal Rrn", accessor: "retrievalReferenceNumber", width: "10%", align: "left" },
      { Header: "Transaction Source", accessor: row => {
        if (row.sdkType === "ANDROID") return "ANDROID";
        if (row.sdkType === "null" || " ") return "WINDOW";
        return row.sdkType;
      }, width: "10%", align: "left" },
      { Header: "Transaction Type", accessor: "transactionType", width: "10%", align: "left" },
      { Header: "CallbackStatus", accessor: "callbackStatus", width: "10%", align: "left" },
    ],
    FailedTransactionsReportColumns: [
      { Header: "rrn", accessor: "retrievalReferenceNumber", width: "10%", align: "left" },
      { Header: "POS ID", accessor: "posId", width: "10%", align: "left" },
      { Header: "Reason", accessor: "reason", width: "10%", align: "left" },
      { Header: "Merchant Id", accessor: "merchantId", width: "10%", align: "left" },
      { Header: "Amount", accessor: "amount", width: "10%", align: "left" },
      { Header: "Transaction Date", accessor: row => readableFormatDate2(row.transactionDate), width: "10%", align: "left" },
    ],
    cardTransactionsReportsColumns: [
      { Header: "Date", accessor: row => readableFormatDate2(row.transactionDate), width: "10%", align: "left", Cell: ({ value, row }) => row.original.status === '01' || row.original.status === '02' ? <span style={{ textDecoration: 'line-through', color: '#d32f2f' }}>{value}</span> : value },
      // { Header: "Company Name", accessor: "compName", width: "10%", align: "left" },
      // { Header: "Device SN", accessor: "deviceSn", width: "10%", align: "left" },
      // { Header: "Device Type", accessor: "transactionNumber", width: "10%", align: "left" },
      { Header: "MID", accessor: "merchantId", width: "10%", align: "left", Cell: ({ value, row }) => row.original.status === '01' || row.original.status === '02' ? <span style={{ textDecoration: 'line-through', color: '#d32f2f' }}>{value}</span> : value },
      { Header: "TID", accessor: "posId", width: "10%", align: "left", Cell: ({ value, row }) => row.original.status === '01' || row.original.status === '02' ? <span style={{ textDecoration: 'line-through', color: '#d32f2f' }}>{value}</span> : value },
      { Header: "Amount", accessor: row => formatNumber(row.amount), width: "10%", align: "left", Cell: ({ value, row }) => row.original.status === '01' || row.original.status === '02' ? <span style={{ textDecoration: 'line-through', color: '#d32f2f' }}>{value}</span> : value },
      {
        Header: "Status",
        accessor: row => row.responseCode === '000' || row.responseCode === '00' ? 'Approved ( '+row.responseCode+' )' : 'Declined ( '+row.responseCode+' )',
        width: "10%",
        align: "left",
        Cell: ({ value, row }) => {
          const isApproved = value && value.startsWith('Approved');
          const isVoidedOrRefunded = row.original.status === '01' || row.original.status === '02';
          return (
            <MDBox
              sx={{
                display: "inline-block",
                px: 1.5,
                py: 0.5,
                borderRadius: "8px",
                backgroundColor: isApproved ? "#d4edda" : "#f8d7da",
                color: isApproved ? "#155724" : "#721c24",
                fontWeight: "500",
                fontSize: "0.75rem",
                whiteSpace: "nowrap",
                ...(isVoidedOrRefunded && { textDecoration: 'line-through' }),
              }}
            >
              {value}
            </MDBox>
          );
        },
      },
      {
        Header: "RRN", accessor: "retrievalReferenceNumber", width: "10%", align: "left",
        Cell: ({ value, row }) => {
          const isVoidedOrRefunded = row.original.status === '01' || row.original.status === '02';
          const [copied, setCopied] = useState(false);
          const [hovered, setHovered] = useState(false);
          const handleCopy = (e) => {
            e.stopPropagation();
            if (value) { navigator.clipboard.writeText(value).then(() => { setCopied(true); setTimeout(() => setCopied(false), 1500); }); }
          };
          return (
            <span
              style={{ display: "inline-flex", alignItems: "center", gap: "4px", textDecoration: isVoidedOrRefunded ? "line-through" : "none", color: isVoidedOrRefunded ? "#d32f2f" : "inherit", cursor: "default" }}
              onMouseEnter={() => setHovered(true)}
              onMouseLeave={() => setHovered(false)}
            >
              {value}
              {value && (
                <Tooltip title={copied ? "Copied!" : "Copy RRN"} placement="top">
                  <span
                    onClick={handleCopy}
                    style={{ cursor: "pointer", display: "inline-flex", alignItems: "center", color: copied ? "#4caf50" : "#757575", fontSize: "1.4rem", lineHeight: 1, visibility: hovered ? "visible" : "hidden" }}
                  >
                    {copied ? "✓" : "⎘"}
                  </span>
                </Tooltip>
              )}
            </span>
          );
        },
      },
      {
        Header: "Transaction Method",
        accessor: row => {
          const entrMode = row.entrMode;
          if (!entrMode) {
            return null;
          } else if (entrMode.startsWith("05")) {
            return "Contact";
          } else if (entrMode.startsWith("07")) {
            return "Contactless";
          } else if (entrMode.startsWith("02")) {
            return "Mag Stripe";
          } else if (entrMode.startsWith("01")) {
            return "Manual";
          } else {
            return "Other";
          }
        },
        width: "10%",
        align: "left",
        Cell: ({ value, row }) => {
          if (!value) return null;
          const isVoidedOrRefunded = row.original.status === '01' || row.original.status === '02';
          const colorMap = {
            "Contact":      { bg: "#d1ecf1", color: "#0c5460" },
            "Contactless":  { bg: "#e2d9f3", color: "#432874" },
            "Mag Stripe":   { bg: "#fff3cd", color: "#856404" },
            "Manual":       { bg: "#fde8d8", color: "#7d3c0f" },
            "Other":        { bg: "#e2e3e5", color: "#383d41" },
          };
          const style = colorMap[value] || colorMap["Other"];
          return (
            <MDBox
              sx={{
                display: "inline-block",
                px: 1.5,
                py: 0.5,
                borderRadius: "8px",
                backgroundColor: style.bg,
                color: style.color,
                fontWeight: "500",
                fontSize: "0.75rem",
                whiteSpace: "nowrap",
                ...(isVoidedOrRefunded && { textDecoration: 'line-through' }),
              }}
            >
              {value}
            </MDBox>
          );
        },
      },

      // { Header: "VLE Name", accessor: "vleName", width: "10%", align: "left" },
      {
        Header: "Refund/Void",
        accessor: row => row.status === '01' ? 'Voided' : row.status === '02' ? 'Refunded' : '',
        width: "10%",
        align: "left",
        // Cell: ({ value }) => value ? (
        //   <MDBox component="span" sx={{ textDecoration: "line-through", color: "#888" }}>
        //     {value}
        //   </MDBox>
        // ) : null,
      },
      // { Header: "Refund Status", accessor: row => row.status === '02' ? 'Refunded' : '', width: "10%", align: "left" },
      // { Header: "Surcharge Amount", accessor: row => formatNumber(row.surchangeAmount), width: "10%", align: "left" },
      // { Header: "Tip Amount", accessor: row => formatNumber(row.tipAmount), width: "10%", align: "left" },
      { Header: "Card number", accessor: "pan", width: "10%", align: "left", Cell: ({ value, row }) => row.original.status === '01' || row.original.status === '02' ? <span style={{ textDecoration: 'line-through', color: '#d32f2f' }}>{value}</span> : value },
      { Header: "Invoice Number", accessor: "invoiceNo", width: "10%", align: "left", Cell: ({ value, row }) => row.original.status === '01' || row.original.status === '02' ? <span style={{ textDecoration: 'line-through', color: '#d32f2f' }}>{value}</span> : value },
      { Header: "Auth Id", accessor: "authId", width: "10%", align: "left", Cell: ({ value, row }) => row.original.status === '01' || row.original.status === '02' ? <span style={{ textDecoration: 'line-through', color: '#d32f2f' }}>{value}</span> : value },
      { Header: "App Name", accessor: "appName", width: "10%", align: "left", Cell: ({ value, row }) => row.original.status === '01' || row.original.status === '02' ? <span style={{ textDecoration: 'line-through', color: '#d32f2f' }}>{value}</span> : value },
    
      { Header: "Terminal rrn", accessor: "mobileRefNo", width: "10%", align: "left", Cell: ({ value, row }) => row.original.status === '01' || row.original.status === '02' ? <span style={{ textDecoration: 'line-through', color: '#d32f2f' }}>{value}</span> : value },
      { Header: "Transaction Type", accessor: row => {
        if (row.transactionType === 'CARDSALE') return 'CARD SALE';
        if (row.transactionType === 'AUTHSALE') return 'AUTH SALE';
        return row.transactionType;
      }, width: "10%", align: "left", Cell: ({ value, row }) => row.original.status === '01' || row.original.status === '02' ? <span style={{ textDecoration: 'line-through', color: '#d32f2f' }}>{value}</span> : value },
      { Header: "Merchant Name", accessor: "compName", width: "10%", align: "left", Cell: ({ value, row }) => row.original.status === '01' || row.original.status === '02' ? <span style={{ textDecoration: 'line-through', color: '#d32f2f' }}>{value}</span> : value },
    
      // { Header: "TxnSource", accessor: row => {
      //   if (row.sdkType === "ANDROID") return "ANDROID";
      //   if (row.sdkType === null || " ") return "WINDOW";
      //   return row.sdkType;
      // }, width: "10%", align: "left"},
     // { Header: "Reversal Status", accessor: row => row.status=== "00" ? '' : row.status === "01" && 'Void Transaction', width: "10%", align: "left" },
     // { Header: "Refund Status", accessor: row => row.status=== "00" ? '' : row.status === "02" && 'Refund Transaction', width: "10%", align: "left" },
    ],
    successfulTransactionsReportsColumns: [
      { Header: "Transaction Date", accessor: row => readableFormatDate2(row.transactionDate), width: "10%", align: "left" },
      { Header: "POS Id", accessor: "posId", width: "10%", align: "left" },
      { Header: "rrn", accessor: "retrievalReferenceNumber", width: "10%", align: "left" },
      { Header: "Invoice Number", accessor: "invoiceNo", width: "10%", align: "left" },
      { Header: "Transaction Type", accessor: row => {
        if (row.transactionType === 'CARDSALE') return 'CARDSALE';
        if (row.transactionType === 'AUTHSALE') return 'AUTHSALE';
        return row.transactionType;
      }, width: "10%", align: "left" },
      { Header: "Amount", accessor: row => formatNumber(row.amount), width: "10%", align: "left" },
      { Header: "Status", accessor: row => row.responseCode === '000' || row.responseCode === '00' ? 'Approved ( '+row.responseCode+' )' : 'Declined ( '+row.responseCode+' )', width: "10%", align: "left" },
      { Header: "Merchant Name", accessor: "merchantId", width: "10%", align: "left" },
      { Header: "Reversal Status", accessor: row => row.status === '01' ? 'Voided' : '', width: "10%", align: "left" },
      { Header: "Refund Status", accessor: row => row.status === '02' ? 'Refunded' : '', width: "10%", align: "left" },
      // { Header: "Surcharge Amount", accessor: row => formatNumber(row.surchangeAmount), width: "10%", align: "left" },
      // { Header: "Tip Amount", accessor: row => formatNumber(row.tipAmount), width: "10%", align: "left" },
      { Header: "User Name", accessor: "userName", width: "10%", align: "left" },
      { Header: "Card number", accessor: "pan", width: "10%", align: "left" },
      // { Header: "Entry Mode", accessor: "entrMode", width: "10%", align: "left" },
      { Header: "A Id", accessor: "aid", width: "10%", align: "left" },
      { Header: "Terminal rrn", accessor: "mobileRefNo", width: "10%", align: "left" },
      {
        Header: "Transaction Method",
        accessor: row => {
          const entrMode = row.entrMode;
          if (!entrMode) {
            return null;
          } else if (entrMode.startsWith("05")) {
            return "Chip-In";
          } else if (entrMode.startsWith("07")) {
            return "NFC";
          } else if (entrMode.startsWith("02")) {
            return "Mag Stripe";
          } else {
            return "Other"; // Default case for any other conditions
          }
        },
        width: "10%",
        align: "left"
      },
      // { Header: "TxnSource", accessor: row => {
      //   if (row.sdkType === "ANDROID") return "ANDROID";
      //   if (row.sdkType === null || " ") return "WINDOW";
      //   return row.sdkType;
      // }, width: "10%", align: "left"},
     // { Header: "Reversal Status", accessor: row => row.status=== "00" ? '' : row.status === "01" && 'Void Transaction', width: "10%", align: "left" },
     // { Header: "Refund Status", accessor: row => row.status=== "00" ? '' : row.status === "02" && 'Refund Transaction', width: "10%", align: "left" },
    ],
    dwhTransactionsReportsColumns: [
      { Header: "Transaction Date", accessor: row => readableFormatDate2(row.transactionDate), width: "10%", align: "left" },
      { Header: "Terminal Id", accessor: "posId", width: "10%", align: "left" },
      { Header: "Merchant Id", accessor: "merchantId", width: "10%", align: "left" },
      // { Header: "Device Type", accessor: "transactionNumber", width: "10%", align: "left" },
      { Header: "Merchant Name", accessor: "compName", width: "10%", align: "left" },
      { Header: "Device Type", accessor: "deviceType", width: "10%", align: "left" },      
      { Header: "Transaction Type", accessor: "transactionType", width: "10%", align: "left" },
      { Header: "Amount", accessor: row => formatNumber(row.amount), width: "10%", align: "left" },
      { Header: "rrn", accessor: "retrievalreferencenumber", width: "10%", align: "left" },
      { Header: "Card number", accessor: "pan", width: "10%", align: "left" },
      { Header: "Invoice Number", accessor: "invoiceNo", width: "10%", align: "left" },
      { Header: "Status", accessor: row => row.responsecode === '000' || row.responsecode === '00' ? 'Success' : 'Fail', width: "10%", align: "left" },
      { Header: "Reason", accessor: row => row.responsecode === '000' || row.responsecode === '00' ? 'Approved ( '+row.responsecode+' )' : 'Declined ( '+row.responsecode+' )', width: "10%", align: "left" },
     // { Header: "Reversal Status", accessor: row => row.status=== "00" ? '' : row.status === "01" && 'Void Transaction', width: "10%", align: "left" },
     // { Header: "Refund Status", accessor: row => row.status=== "00" ? '' : row.status === "02" && 'Refund Transaction', width: "10%", align: "left" },
    ],
    voidTransactionsReportsColumns: [
      { Header: "Date", accessor: row => readableFormatDate2(row.transactionDate), width: "10%", align: "left" },
      { Header: "MID", accessor: "merchantId", width: "10%", align: "left" },
      { Header: "TID", accessor: "posId", width: "10%", align: "left" },
      { Header: "Amount", accessor: row => formatNumber(row.amount), width: "10%", align: "left" },
      {
        Header: "Status",
        accessor: row => row.responseCode === '000' || row.responseCode === '00' ? 'Approved ( '+row.responseCode+' )' : 'Declined ( '+row.responseCode+' )',
        width: "10%",
        align: "left",
        Cell: ({ value }) => {
          const isApproved = value && value.startsWith('Approved');
          return (
            <MDBox sx={{ display: "inline-block", px: 1.5, py: 0.5, borderRadius: "8px", backgroundColor: isApproved ? "#d4edda" : "#f8d7da", color: isApproved ? "#155724" : "#721c24", fontWeight: "500", fontSize: "0.75rem", whiteSpace: "nowrap" }}>
              {value}
            </MDBox>
          );
        },
      },
      { Header: "rrn", accessor: "retrievalReferenceNumber", width: "10%", align: "left" },
      { Header: "Terminal rrn", accessor: "mobileRefNo", width: "10%", align: "left" },
      
      { Header: "Transaction Type", accessor: row => {
        if (row.transactionType === "CARDSALE") return "CARDSALE";
        if (row.transactionType === 'AUTHSALE') return "AUTH SALE";
        return row.transactionType;
      }, width: "10%", align: "left" },
      
          
      { Header: "Invoice Number", accessor: "invoiceNo", width: "10%", align: "left" },
      { Header: "Auth Id", accessor: "authid", width: "10%", align: "left" },
      
    ],
    refundTransactionsReportsColumns: [
      { Header: "Transaction Date", accessor: row => readableFormatDate2(row.transactionDate), width: "10%", align: "left" },

      { Header: "Terminal Id", accessor: "posId", width: "10%", align: "left" },
      { Header: "Merchant Id", accessor: "merchantId", width: "10%", align: "left" },
      // { Header: "Device Type", accessor: "transactionNumber", width: "10%", align: "left" },
      { Header: "Merchant Name", accessor: "compName", width: "10%", align: "left" },
      { Header: "Transaction Type", accessor: "transactionType", width: "10%", align: "left" },
      { Header: "Amount", accessor: row => formatNumber(row.amount), width: "10%", align: "left" },
      { Header: "rrn", accessor: "retrievalreferencenumber", width: "10%", align: "left" },
      { Header: "Card number", accessor: "pan", width: "10%", align: "left" },
      { Header: "Invoice Number", accessor: "invoiceNo", width: "10%", align: "left" },
      { Header: "Auth Id", accessor: "authid", width: "10%", align: "left" },
      { Header: "Terminal rrn", accessor: "mobileRefNo", width: "10%", align: "left" },
      { Header: "Read Type", accessor: row => row.aid== null || row.aid===""  ? 'MAG' : 'ICC', width: "10%", align: "left" },
      { Header: "Status", accessor: row => row.responsecode === '000' || row.responsecode === '00' ? 'Success' : 'Fail', width: "10%", align: "left" },
      { Header: "Reason", accessor: row => row.responsecode === '000' || row.responsecode === '00' ? 'Approved ( '+row.responsecode+' )' : 'Declined ( '+row.responsecode+' )', width: "10%", align: "left" },
      //{ Header: "Reversal Status", accessor: row => row.status=== "00" ? '' : row.status === "01" && 'Void Transaction', width: "10%", align: "left" },
      //{ Header: "Refund Status", accessor: row => row.status=== "00" ? '' : row.status === "02" && 'Refund Transaction', width: "10%", align: "left" },
    ],
    emailTablecolumns: [
      { Header: "Email Id", accessor: "emailid", width: "10%", align: "left" },
      { Header: "Date", accessor: row => readableFormatDate2(row.maildate), width: "10%", align: "left" },
      { Header: "email", accessor: "email", width: "10%", align: "left" },
      { Header: "Status", accessor: "response", width: "10%", align: "left" }
    ],
    smsTablecolumns: [
      { Header: "Mobile Number", accessor: "mobileNo", width: "10%", align: "left" },
      { Header: "Merchant name / Reference Company Name / Name", accessor: "userDisplayName", width: "10%", align: "left" },
      { Header: "Date", accessor: row => readableFormatDate2(row.otpDate), width: "10%", align: "left" },
      { Header: "SMS", accessor: "sms", width: "10%", align: "left" },
      { Header: "Status", accessor: row => row.status === "3" ? "Delivered" : " Not Delivered", width: "10%", align: "left" }
    ],
    onboardingFilesTableColumns: [
      { Header: "MBF File Name", accessor: "mbfFileName", width: "10%", align: "left" },
      { Header: "MBF Total Records", accessor: "mbfTotalRecords", width: "10%", align: "left" },
      { Header: "BRF File Name", accessor: "brfFileName", width: "10%", align: "left" },
      { Header: "BRF Total Records", accessor: "brfTotalRecords", width: "10%", align: "left" },
      { Header: "BSR File Name", accessor: "bsrFileName", width: "10%", align: "left" },
      { Header: "BSR Total Records", accessor: "bsrTotalRecords", width: "10%", align: "left" },
      { Header: "BSR Total Processed Records", accessor: "bsrTotalProcessedRecords", width: "10%", align: "left" },
      { Header: "Total Processed Records", accessor: "totalProcessedRecords", width: "10%", align: "left" }
    ],
    cardSettlementSummaryTableColumns: [
      { Header: "Date", accessor: "date", width: "10%", align: "left" },
      { Header: "MID", accessor: "merchantId", width: "10%", align: "left" },
      { Header: "Total Sales", accessor: "salesNo", width: "10%", align: "left" },
      { Header: "Total Sales Amount", accessor: row => formatNumber(row.salesTotal), width: "10%", align: "left" },
      { Header: "Total MSF Charged", accessor: row => formatNumber(row.msfCharged), width: "10%", align: "left" },
      { Header: "Total Refunds", accessor: "refundsNo", width: "10%", align: "left" },
      { Header: "Total Refunds Amount", accessor: row => formatNumber(row.refundsTotal), width: "10%", align: "left" },
      { Header: "Net Total", accessor: row => formatNumber(row.netTotal), width: "10%", align: "left" },
    ],
    mdrMasterTableColumns: [
      { Header: "Merchant id", accessor: "mid", width: "10%", align: "left" },
      { Header: "Merchant name", accessor: "merchantName", width: "10%", align: "left" },
      { Header: "CARDHOLDER SURCHARGE", accessor: "cardHoldercharger", width: "10%", align: "left" },
      { Header: "MERCHANT Msf", accessor: "merchantMDr", width: "10%", align: "left" },
      { Header: "Settlement Type", accessor: "settlementType", width: "10%", align: "left" },
      { Header: "Mdr Type", accessor: "mdrType", width: "10%", align: "left" },
      { Header: "Visa Credit", accessor: "visaCredit", width: "10%", align: "left" },
      { Header: "visa Debit", accessor: "visaDebit", width: "10%", align: "left" },
      { Header: "Diners", accessor: "diners", width: "10%", align: "left" },
  
      { Header: "Jcb", accessor: "jcb", width: "10%", align: "left" },
      { Header: "Master Credit", accessor: "masterCredit", width: "10%", align: "left" },
      { Header: "Eftpos", accessor: "eftpos", width: "10%", align: "left" },
      { Header: "Upi", accessor: "upi", width: "10%", align: "left" },
   
      { Header: "Amex", accessor: "amex", width: "10%", align: "left" },
      { Header: "Eftpos(Msf)", accessor: "eftposMsf", width: "10%", align: "left" },
      { Header: "Others(MSF)", accessor: "others", width: "10%", align: "left" },
      // { Header: "Status", accessor: row => row.status === '0' || row.status === '2' ? 'In Active' : 'Active', width: "10%", align: "left" },
      { Header: "Action", accessor: "action", width: "10%", align: "left" },
    ],
    capkMasterTableColumns: [
      { Header: "DESCRIPTION", accessor: "description", width: "10%", align: "left" },
      { Header: "RID", accessor: "rid", width: "10%", align: "left" },
      { Header: "RID_INDEX", accessor: "ridIndex", width: "10%", align: "left" },
      { Header: "EXPONENT", accessor: "exponent", width: "10%", align: "left" },
      { Header: "MODULUS", accessor: "modulus", width: "10%", align: "left" },
      { Header: "SHA1", accessor: "sha1", width: "10%", align: "left" },
      { Header: "VERSION", accessor: "version", width: "10%", align: "left" },

      { Header: "EXPIRES", accessor: "expires", width: "10%", align: "left" },
  
   
      // { Header: "Status", accessor: row => row.status === '0' || row.status === '2' ? 'In Active' : 'Active', width: "10%", align: "left" },
      { Header: "Action", accessor: "action", width: "10%", align: "left" },
    ],
    
    binMasterTableColumns: [
      { Header: "bin", accessor: "binCode", width: "10%", align: "left" },
      { Header: "bank", accessor: row => row.bankMaster.bankName, width: "10%", align: "left" },
      { Header: "Card type", accessor: row => row.cardTypeMaster.typeName, width: "10%", align: "left" },
      { Header: "Product type", accessor: row => row.productTypeMaster.typeName, width: "10%", align: "left" },
      { Header: "Action", accessor: "action", width: "10%", align: "left" },
    ],
    posTransactionReportsColumns: [
      { Header: "Date", accessor: row => readableFormatDate2(row[0].transactionDate), width: "10%", align: "left" },
      { Header: "PAN", accessor: row => row[0].pan, width: "10%", align: "left" },
      { Header: "Device Type", accessor:row => row[2].deviceType, width: "10%", align: "left" },
      { Header: "MID", accessor: row => row[0].merchantId, width: "10%", align: "left" },
      { Header: "TID", accessor: row => row[0].posId, width: "10%", align: "left" },
      { Header: "Amount", accessor: row => row[0].amount === null ? '00.000' : formatNumber(row[0].amount), width: "10%", align: "left" },
      { Header: "RRN", accessor: row => row[0].retrievalreferencenumber, width: "10%", align: "left" },
      // { Header: "Card Holder Surcharge (%)", accessor:row => row[0].cardSurchagePercentage, width: "10%", align: "left" },
      // { Header: "Card Holder Surcharge Amount", accessor:row => row[0].cardSurchageAmount, width: "10%", align: "left" },
      // { Header: "Merchant Service Fee (%)", accessor: row => row[0].msfPercentage, width: "10%", align: "left" },
      // { Header: "Merchant Service Fee Amount", accessor: row => row[0].msfAmount, width: "10%", align: "left" },
      { Header: "Terminal RRN", accessor: row => row[0].mobileRefNo, width: "10%", align: "left" },
      { Header: "Merchant Name", accessor: row => row[1].companyName, width: "10%", align: "left" },
      { Header: "Response Code", accessor: row => row[0].responsecode, width: "10%", align: "left" },
      { Header: "Status", accessor: row => row[0].responsecode === "00" ? 'Success' : 'Fail', width: "10%", align: "left" },
      { Header: "Reversal Status", accessor: row => row[0].status === '01' ? 'Voided' : '', width: "10%", align: "left" },
      { Header: "Refund Status", accessor: row => row[0].status === '02' ? 'Refunded' : '', width: "10%", align: "left" },
      { Header: "Auth Id", accessor: row => row[0].authid, width: "10%", align: "left" },
      // { Header: "Invoice No", accessor: row => row.invoiceNo, width: "10%", align: "left" },
      { Header: "Application Name", accessor: row => row[0].appName, width: "10%", align: "left" },
      {
        Header: "Transaction Method",
        accessor: row => {
          const entrmode = row[0].entrmode;
          if (entrmode.startsWith("05")) {
            return "Chip-In";
          } else if (entrmode.startsWith("07")) {
            return "NFC";
          } else if (entrmode.startsWith("02")) {
            return "Mag Stripe";
          } else {
            return "Unknown"; // Default case if no match
          }
        },
        width: "10%",
        align: "left"
      },
    ],
    settlementReportsColumns: [
      { Header: "Date", accessor: row => readableFormatDate2(row[0].transactionDate), width: "10%", align: "left" },
      { Header: "PAN", accessor: row => row[0].pan, width: "10%", align: "left" },
      { Header: "RRN", accessor: row => row[0].retrievalreferencenumber, width: "10%", align: "left" },
      { Header: "MID", accessor: row => row[0].merchantId, width: "10%", align: "left" },
      { Header: "TID", accessor: row => row[0].posId, width: "10%", align: "left" },
      { Header: "Amount", accessor: row => row[0].amount === null ? '00.000' : formatNumber(row[0].amount), width: "10%", align: "left" },
      // { Header: "Issuer Name", accessor: row => row[0].issuerName, width: "10%", align: "left" },
      { Header: "Merchant Name", accessor: row => row[1].companyName, width: "10%", align: "left" },
      { Header: "Settlement Account Number", accessor: row => row[1].accountNo, width: "10%", align: "left" },
     
      { Header: "Card Holder Surcharge %", accessor: row => row[0].cardSurchagePercentage, width: "10%", align: "left" },
      { Header: "Card Holder Surcharge Amount", accessor: row => formatNumber(row[0].cardSurchageAmount), width: "10%", align: "left" },
      { Header: "Merchant service fee %", accessor: row => row[0].msfPercentage, width: "10%", align: "left" },
      { Header: "Merchat service fee amount", accessor: row => formatNumber(row[0].msfAmount), width: "10%", align: "left" },
      { Header: "Merchant settlement amount", accessor: row => formatNumber(row[0].merchantSettlementAmount), width: "10%", align: "left" },
      //{ Header: "Device type", accessor: row => row[1].posMachineType, width: "10%", align: "left" },
      { Header: "Application name", accessor: row => row[0].appName, width: "10%", align: "left" },
      // { Header: "Branch Name", accessor: row => row[1].bankerBranchName, width: "10%", align: "left" },
      { Header: "Status", accessor: row => row[0].responsecode === '00' ? 'Success' : 'Fail', width: "10%", align: "left" },
      { Header: "Reversal Status", accessor: row => row[0].status === "01" ? 'Voided' : '', width: "10%", align: "left" },
      { Header: "Refund Status", accessor: row => row[0].status === "01" ? 'Voided' : '', width: "10%", align: "left" },
      { Header: "Auth Id", accessor: row => row[0].authid, width: "10%", align: "left" },
      { Header: "Invoice No", accessor: row => row[0].invoiceNo, width: "10%", align: "left" },
    ],

    
    netSettlementReportsColumns: [
      { Header: "Date", accessor: row => row.settlementDate, width: "10%", align: "left" },
      { Header: "MID", accessor: row => row.merchantId, width: "10%", align: "left" },
      { Header: "Total Sales", accessor: row => row.totalSaleCount, width: "10%", align: "left" },
      { Header: "Total Sales Amount", accessor: row => formatNumber(row.totalSaleAmount), width: "10%", align: "left" },
      { Header: "Msf Charged", accessor: row => formatNumber(row.totalMsfAmount), width: "10%", align: "left" },
      { Header: "Total Refunds", accessor: row => row.totalRefundCount, width: "10%", align: "left" },
      { Header: "Total Refund Amount", accessor: row => formatNumber(row.totalRefundAmount), width: "10%", align: "left" },
      { Header: "Lodgement Reference", accessor: row => row.lodgementRefNumber, width: "10%", align: "left" },
      { Header: "Settlement Amount", accessor: row => formatNumber(row.merchantSettlementAmount), width: "10%", align: "left" },
      // { Header: "Settlement Status", accessor: row => row.settlementStatus, width: "10%", align: "left" }
    ],
    monthlyNetSettlementReportsColumns: [
      { Header: "Date", accessor: row => row.yearMonth, width: "10%", align: "left" },
      { Header: "MID", accessor: row => row.merchantId, width: "10%", align: "left" },
      { Header: "Registered Business Name", accessor: row => row.companyName, width: "10%", align: "left" },
      { Header: "Abn", accessor: row => row.abn, width: "10%", align: "left" },
      { Header: "Email", accessor: row => row.email, width: "10%", align: "left" },
      { Header: "Address", accessor: row => row.address, width: "10%", align: "left" },

      { Header: "Total Sales", accessor: row => row.totalSaleCount, width: "10%", align: "left" },
      { Header: "Total Sales Amount", accessor: row => formatNumber(row.totalSaleAmount), width: "10%", align: "left" },
      { Header: "Msf Charged", accessor: row => formatNumber(row.totalMsfAmount), width: "10%", align: "left" },
      { Header: "Total Refunds", accessor: row => row.totalRefundCount, width: "10%", align: "left" },
      { Header: "Total Refund Amount", accessor: row => formatNumber(row.totalRefundAmount), width: "10%", align: "left" },
      { Header: "Total Settlement Amount", accessor: row => formatNumber(row.totalMerchantSettlementAmount), width: "10%", align: "left" },
      // { Header: "Settlement Status", accessor: row => row.settlementStatus, width: "10%", align: "left" }
    ],
    grossSettlementReportsColumns: [
     { Header: "Date", accessor: row => row.yearMonth, width: "10%", align: "left" },
      { Header: "MID", accessor: row => row.merchantId, width: "10%", align: "left" },
      { Header: "Registered Business Name", accessor: row => row.companyName, width: "10%", align: "left" },
      { Header: "Abn", accessor: row => row.abn, width: "10%", align: "left" },
      { Header: "Email", accessor: row => row.email, width: "10%", align: "left" },
      { Header: "Address", accessor: row => row.address, width: "10%", align: "left" },


      { Header: "Total Sales", accessor: row => row.totalSaleCount, width: "10%", align: "left" },
      { Header: "Total Sales Amount", accessor: row => row.totalSaleAmount, width: "10%", align: "left" },
    //  { Header: "Total Refunds", accessor: row => row.totalRefundAmount, width: "10%", align: "left" },
      { Header: "Settlement Amount", accessor: row => row.totalMerchantSettlementAmount, width: "10%", align: "left" },
     // { Header: "Msf", accessor: row => row.merchantMDr, width: "10%", align: "left" },
      { Header: "Total IC Amount", accessor: row => row.totalIcAmt, width: "10%", align: "left" },
      { Header: "Total Refunds", accessor: row => row.totalRefundCount, width: "10%", align: "left" },
      { Header: "Total Refund Amount", accessor: row => formatNumber(row.totalRefundAmount), width: "10%", align: "left" },
  
      // { Header: "Settlement Status", accessor: row => row.settlementStatus, width: "10%", align: "left" }
    ],
    ruleTableColumns: [
      { Header: "Rule Id", accessor: "ruleID", width: "10%", align: "left" },
      { Header: "Rule", accessor: rule => 'IF '+rule.conditionField.toUpperCase()+' IS '+ (rule.conditionOperator.toUpperCase() === 'BETWEEN' ? ' FROM '+rule.conditionFromValue+' TO '+rule.conditionToValue  : rule.conditionFromValue)
          +' THEN ACQUIRER IS '+rule.acquirer.name, width: "10%", align: "left" },
      { Header: "Action", accessor: "action", width: "10%", align: "left" }
    ],
    merchantStatementColumns: [
      { Header: "MID", accessor: "mid", width: "10%", align: "left" },
      { Header: "Statement Month", accessor: row => monthConverter(row.statementDate), width: "10%", align: "left" },
      { Header: "Generated on", accessor: row => readableFormatDate(row.createdAt), width: "10%", align: "left" },
      { Header: "Action", accessor: "action", width: "10%", align: "left" }
    ],

    DeFileReleaseScreenColumns: [
      { Header: "Date", accessor: row => readableFormatDate2(row.createdTs) , width: "10%", align: "left" },

      { Header: "File Name ", accessor: "fileName", width: "10%", align: "left" ,  Cell: ({ value }) => (
        <span style={{ color: "red", fontWeight: "bold" }}>{value}</span> // Setting text color to red and making it bold
      ),},
      { Header: "DWH File Name", accessor: "dwhFileName", width: "10%", align: "left" },
      { Header: "Settlement Date", accessor: "settlementDate", width: "10%", align: "left" },
      { Header: "Total Records", accessor: "totalRecords", width: "10%", align: "left" },

      { Header: "File Value", accessor: "deFileValue", width: "10%", align: "left" },
        { Header: "IS Send Fiserv", accessor: "isPushedFiserv", width: "10%", align: "left" },
        { 
          Header: "Send Timestamp", 
          accessor: row => {
            const timestamp = row.fiservTimpStamp;
            return timestamp ? readableFormatDate2(timestamp) : null; // Change null to "" if you want an empty string
          }, 
          width: "10%", 
          align: "left" 
        },
        
      { Header: "Download", accessor: "action", width: "10%", align: "left" }
    ],

   DwhFileProccessColumns: [
      { Header: "Date", accessor: row => readableFormatDate2(row.createdTs), width: "10%", align: "left" },

      { Header: "File Name ", accessor: "fileName", width: "10%", align: "left",  Cell: ({ value }) => (
        <span style={{ color: "red", fontWeight: "bold" }}>{value}</span> // Setting text color to red and making it bold
      ), },
      {
        Header: "Is Processed",
        accessor: "flag",
        width: "10%",
        align: "left",
        Cell: ({ value }) => (value ? "Y" : "N") // Custom rendering logic
      }
,      

      { Header: "Download", accessor: "action", width: "10%", align: "left" }
    ],
    DeReplyColumns: [
      { Header: "Date", accessor: row => readableFormatDate2(row.createdTs), width: "10%", align: "left" },

      { Header: "DE File", accessor: "deFileName", width: "10%", align: "left" },
      { Header: "De Reply File ", accessor: "fileName", width: "10%", align: "left", Cell: ({ value }) => (
        <span style={{ color: "red", fontWeight: "bold" }}>{value}</span> // Setting text color to red and making it bold
      ), },
      { Header: "Total Records", accessor: "totalRecords", width: "10%", align: "left" },
   
      { Header: "Download", accessor: "action", width: "10%", align: "left" }
    ],
    paymentLinkColumns: [
      { Header: "Description", accessor: "description", width: "12%", align: "left" },
      { Header: "Amount", accessor: row => `${formatNumber(row.amount)} ${row.currency ?? ""}`, width: "10%", align: "left" },
      { Header: "Status", accessor: "paymentLinkStatus", width: "10%", align: "left" },
      { Header: "Quantity", accessor: "quantity", width: "8%", align: "left" },
      { Header: "QR Payments", accessor: "qrPayments", width: "8%", align: "left" },
      { Header: "Direct Payments", accessor: "directLinkPayments", width: "10%", align: "left" },
      { Header: "Total Payments", accessor: "totalPayments", width: "10%", align: "left" },
      { Header: "Valid From", accessor: "validFromDate", width: "12%", align: "left" },
      { Header: "Valid Till", accessor: row => row.validTillDate ?? "—", width: "10%", align: "left" },
      { Header: "Has QR", accessor: row => row.hasQr ? "Yes" : "No", width: "8%", align: "left" },
    ],
    invoiceColumns: [
      { Header: "Invoice No", accessor: "invoiceNumber", width: "10%", align: "left" },
      { Header: "Created Date", accessor: row => readableFormatDate2(row.createdDate), width: "10%", align: "left" },
      { Header: "Billing To", accessor: "billingCompany", width: "10%", align: "left" },
      { Header: "Currency", accessor: "currency", width: "10%", align: "left" },
      { Header: "Amount", accessor: "totalAmount", width: "10%", align: "left" },
      { Header: "Status", accessor: "customerName", width: "10%", align: "left" },
      { Header: "Customer name", accessor: "customerName", width: "10%", align: "left" },
      { Header: "Customer Email", accessor: "customerEmail", width: "10%", align: "left" },
      { Header: "Due Date", accessor: row => readableFormatDate2(row.dueDate), width: "10%", align: "left" },
    ],
    merchantTransactionDetailsColumns: [
      { Header: "Merchant Name", accessor: row => row.merchant?.cardAcceptorName ?? "—", width: "10%", align: "left" },
      { Header: "Date", accessor: "createdTime", width: "10%", align: "left" },
      { Header: "MID", accessor: row => row.merchant?.cardAcceptorCode ?? "—", width: "10%", align: "left" },
      {
        Header: "Amount",
        accessor: row => `${formatNumber(parseFloat(row.amountInCents || 0) / 100)} (${row.currency ?? ""})`,
        width: "9%",
        align: "left",
      },
      {
        Header: "Status",
        accessor: row => row.status,
        width: "8%",
        align: "left",
        Cell: ({ value }) => {
          const STATUS_COLORS = {
            INITIATED:            { bg: "#e2e3e5", color: "#383d41" },
            AUTHORIZED:           { bg: "#d4edda", color: "#155724" },
            CAPTURED:             { bg: "#cce5ff", color: "#004085" },
            FAILED:               { bg: "#f8d7da", color: "#721c24" },
            COMPLETED:            { bg: "#c3e6cb", color: "#1e7e34" },
            SETTLEMENT_INITIATED: { bg: "#d1ecf1", color: "#0c5460" },
            SETTLED:              { bg: "#bee5eb", color: "#0c5460" },
            VOID:                 { bg: "#fff3cd", color: "#856404" },
            VOID_UNSUCCESSFULL:   { bg: "#f5c6cb", color: "#721c24" },
          };
          const s = STATUS_COLORS[value] ?? { bg: "#e2e3e5", color: "#383d41" };
          return (
            <MDBox title={value} sx={{ display: "inline-block", px: 1.5, py: 0.4, borderRadius: "8px", backgroundColor: s.bg, color: s.color, fontWeight: "500", fontSize: "0.75rem", whiteSpace: "nowrap" }}>
              {mapTransactionStatus(value)}
            </MDBox>
          );
        },
      },
      { Header: "Processor", accessor: row => row.processorType || "—", width: "12%", align: "left" },
      {
        Header: "Card",
        accessor: row => row.card ? `${row.card.brand} ****${row.card.last4}` : "—",
        width: "10%",
        align: "left",
      },
      { Header: "Payment Method", accessor: "paymentMethodType", width: "8%", align: "left" },
      {
        Header: "QR Payment",
        accessor: row => row.isQrPayment ? "Yes" : "No",
        width: "6%",
        align: "left",
      },
      ...[
        { Header: "Session ID",       accessor: "sessionId" },
        { Header: "Payment Link ID",  accessor: "paymentLinkId" },
        { Header: "Reference ID",     accessor: "referenceId" },
        { Header: "Refund Reference", accessor: "lastRefundId" },
      ].map(({ Header, accessor }) => ({
        Header,
        accessor,
        width: "8%",
        align: "left",
        Cell: ({ value }) => {
          const [copied, setCopied] = useState(false);
          const [hovered, setHovered] = useState(false);
          const handleCopy = (e) => {
            e.stopPropagation();
            if (value) navigator.clipboard.writeText(value).then(() => { setCopied(true); setTimeout(() => setCopied(false), 1500); });
          };
          return (
            <Tooltip title={value ?? ""} placement="top">
              <span
                style={{ display: "inline-flex", alignItems: "center", gap: "4px", cursor: "default" }}
                onMouseEnter={() => setHovered(true)}
                onMouseLeave={() => setHovered(false)}
              >
                <span style={{ maxWidth: 72, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", display: "inline-block", verticalAlign: "middle" }}>
                  {value ? `${value.slice(0, 8)}…` : "—"}
                </span>
                {value && (
                  <span
                    onClick={handleCopy}
                    style={{ cursor: "pointer", color: copied ? "#4caf50" : "#9e9e9e", fontSize: "1rem", visibility: hovered ? "visible" : "hidden", flexShrink: 0 }}
                  >
                    {copied ? "✓" : "⎘"}
                  </span>
                )}
              </span>
            </Tooltip>
          );
        },
      })),
      {
        Header: "Refund Status",
        accessor: "refundStatus",
        width: "8%",
        align: "left",
        Cell: ({ value }) => {
          if (!value) return <span>—</span>;
          const REFUND_STATUS_COLORS = {
            SUCCESS: { bg: "#d4edda", color: "#155724" },
            PENDING: { bg: "#fff3cd", color: "#856404" },
            FAILED:  { bg: "#f8d7da", color: "#721c24" },
          };
          const s = REFUND_STATUS_COLORS[value] ?? { bg: "#e2e3e5", color: "#383d41" };
          return (
            <MDBox sx={{ display: "inline-block", px: 1.5, py: 0.4, borderRadius: "8px", backgroundColor: s.bg, color: s.color, fontWeight: "500", fontSize: "0.75rem", whiteSpace: "nowrap" }}>
              {value}
            </MDBox>
          );
        },
      },
      {
        Header: "Refund Amount",
        accessor: row => row.refundedAmountInCents != null
          ? `${(parseFloat(row.refundedAmountInCents) / 100).toFixed(2)} ${row.currency ?? ""}`.trim()
          : "—",
        width: "8%",
        align: "left",
      },
      { Header: "Payer IP", accessor: row => row.ipAddress || "—", width: "8%", align: "left" },
    ],
    merchantTransactionSummaryColumns: [
      { Header: "Date", accessor: "date", width: "10%", align: "left" },
      {
        Header: "Status",
        accessor: row => row.status,
        width: "10%",
        align: "left",
        Cell: ({ value }) => {
          const STATUS_COLORS = {
            INITIATED:            { bg: "#e2e3e5", color: "#383d41" },
            AUTHORIZED:           { bg: "#d4edda", color: "#155724" },
            CAPTURED:             { bg: "#cce5ff", color: "#004085" },
            FAILED:               { bg: "#f8d7da", color: "#721c24" },
            COMPLETED:            { bg: "#c3e6cb", color: "#1e7e34" },
            SETTLEMENT_INITIATED: { bg: "#d1ecf1", color: "#0c5460" },
            SETTLED:              { bg: "#bee5eb", color: "#0c5460" },
            VOID:                 { bg: "#fff3cd", color: "#856404" },
            VOID_UNSUCCESSFULL:   { bg: "#f5c6cb", color: "#721c24" },
          };
          const s = STATUS_COLORS[value] ?? { bg: "#e2e3e5", color: "#383d41" };
          return (
            <MDBox title={value} sx={{ display: "inline-block", px: 1.5, py: 0.4, borderRadius: "8px", backgroundColor: s.bg, color: s.color, fontWeight: "500", fontSize: "0.75rem", whiteSpace: "nowrap" }}>
              {mapTransactionStatus(value)}
            </MDBox>
          );
        },
      },
      { Header: "Payment Type", accessor: "paymentType", width: "10%", align: "left" },
      { Header: "Currency", accessor: "currency", width: "8%", align: "left" },
      {
        Header: "Amount",
        accessor: row => formatNumber(parseFloat(row.amount || 0) / 100),
        width: "10%",
        align: "left",
      },
      { Header: "No. of Transactions", accessor: "totalNumOfTrans", width: "12%", align: "left" },
      { Header: "Settlement Status", accessor: "settlementStatus", width: "12%", align: "left" },
    ],
  };
}
